import axios from "axios";
import qs from "qs";
import moment from 'moment'

const state = {
  venues: [],
  venueList: [],
  venue: {},
  coffeeSizes: [],
  resources: [],
  milkTypes: [],
  cityList: [],
  districtList: {},
  coffeeOptions: [],
  loading: false,
  importResponse: {},
};

const getters = {
  allVenues: (state) => state.venues,
  allVenueList: (state) => state.venueList,
  venueData: (state) => state.venue,
  allCoffeeSize: (state) => state.coffeeSizes,
  allResources: (state) => state.resources,
  allMilkTypes: (state) => state.milkTypes,
  allCities: (state) => state.cityList,
  allCoffeeOptions: (state) => state.coffeeOptions,
  loading: (state) => state.loading,
  importResponse: (state) => state.importResponse,
};

const actions = {
  getVenues({ commit }, companyId) {
    return axios
      .get(`/api/panel/venue/venue-name-list/${companyId}`)
      .then((response) => {
        commit("setVenues", response.data.payload);
        return response.data.payload;
      });
  },
  getPanelUserVenues({ commit }, id) {
    return axios
      .get(`/api/panel/paneluser/get-panel-user-venues/${id}`)
      .then((response) => {
        commit("setVenues", response.data.payload);
        return response.data.payload;
      });
  },
  getVenueList({ commit }, query) {
    commit("setLoading", true);
    const queryString = qs.stringify({
      page: query.pageNumber,
      size: query.pageSize,
      search: query.search,
      cityId: query.cityId,
      districtId: query.districtId,
      companyId: query.companyId,
      isActive: query.filterByStatus,
      hasPlusPackage: query.hasPlusPackage,
    },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== '' ? value : undefined),
      });

    return axios
      .get(
        `/api/panel/venue/venue-list?${queryString}`)
      .then((response) => {
        commit("setAllVenues", response.data.payload.items);
        commit("setLoading", false);
        return response.data.payload;
      });
  },
  getVenue({ commit }, venue) {
    return axios
      .get(`/api/panel/venue/detail/${venue.id}`)
      .then((response) => {
        commit("setVenue", response.data.payload);
        return response.data.payload;
      });
  },
  getCoffeeSizeList({ commit }) {
    return axios.get(`/api/panel/venue/coffee-size-list`).then((response) => {
      commit("setCoffeeSizes", response.data.payload);
      return response.data.payload;
    });
  },
  getResourceList({ commit }) {
    return axios.get(`/api/panel/venue/resource-list`).then((response) => {
      commit("setResources", response.data.payload);
      return response.data.payload;
    });
  },
  getCoffeeOptionList({ commit }) {
    return axios.get(`/api/panel/venue/coffee-option-list`).then((response) => {
      commit("setCoffeeOptions", response.data.payload);
      return response.data.payload;
    });
  },
  getMilkTypeList({ commit }) {
    return axios.get(`/api/panel/venue/milk-type-list`).then((response) => {
      commit("setMilkTypes", response.data.payload);
      return response.data.payload;
    });
  },
  getCityList({ commit }) {
    return axios.get(`/api/public/city`).then((response) => {
      commit("setCities", response.data.payload);
      return response.data.payload;
    });
  },
  getDistrictList({ commit }, cityId) {
    if (!cityId) return;
    return axios
      .get(`/api/public/district?cityId=${cityId}`)
      .then((response) => {
        commit("setDistricts", response.data.payload);
        return response.data.payload;
      });
  },
  postUpdateActiveVenue({ commit }, venue) {
    return axios
      .put("/api/panel/venue/update-status", {
        venueId: venue.id,
        status: venue.isOpen,
      })
      .then((response) => {
        return response.data;
      });
  },
  addVenue({ commit }, venue) {
    return axios
      .post("/api/panel/venue/create-venue", venue)
      .then((response) => {
        return response.data;
      });
  },
  updateMilkTypes({ commit }, milkTypes) {
    commit("setMilkTypes", milkTypes);
  },
  updateVenue({ commit }, venue) {
    venue.freeEndDate = venue.freeEndDate ? moment(venue.freeEndDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : venue.freeEndDate
    return axios
      .put("/api/panel/venue/update-venue", venue)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  async importWorkingHours({ commit }, file) {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await axios.put(
        "/api/panel/venue/update-working-hours",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data)
        commit("setImportResponse", {
          success: !response.data.payload.message,
          message: response.data.payload.message,
          logFileUrl: response.data.payload.url,
        });
    } catch (error) {
      {
        commit("setImportResponse", {
          success: false,
          message: "An error occurred while processing your request.",
        });
      }
    }
  },
  exportVenueTemplate({ commit }) {
    axios({
      url: `https://frink.mncdn.com/template/working-hour.xlsx`,
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Working-Hour-Template.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  },
  downloadLogFile({ commit }, url) {
    axios({
      url: url,
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `working-hours-error-log-${new Date().toISOString().substr(0, 10)}.txt`
      );
      document.body.appendChild(link);
      link.click();
    });
  },
  exportVenues({ commit }, query) {

    const queryString = qs.stringify(
      {
        statusFilter: query.filterByStatus,
        cityId: query.cityId,
        districtId: query.districtId,
        companyId: query.companyId,
        hasPlusPackage: query.hasPlusPackage,
        search: query.search,
      },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== '' ? value : undefined),
      }
    );

    axios({
      url: `/api/panel/venue/export-venue-working-hour-list?${queryString}`,
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `working-hours-${new Date().toISOString().substr(0, 10)}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
    });
  },
};

const mutations = {
  setVenues: (state, venues) => {
    state.venues = venues;
  },
  setAllVenues: (state, venues) => {
    state.venueList = venues;
  },
  setVenue: (state, venue) => {
    state.venue = venue;
  },
  setCoffeeSizes: (state, coffeeSizes) => {
    state.coffeeSizes = coffeeSizes;
  },
  setResources: (state, resources) => {
    state.resources = resources;
  },
  setCoffeeOptions: (state, coffeeOptions) => {
    state.coffeeOptions = coffeeOptions;
  },
  setMilkTypes: (state, milkTypes) => {
    state.milkTypes = milkTypes;
  },
  setCities: (state, cityList) => {
    state.cityList = cityList;
  },
  setDistricts: (state, districtList) => {
    state.districtList = districtList;
  },
  setDistrict: (state, district) => {
    state.district = district;
  },
  setLoading(state, value) {
    state.loading = value;
  },
  setImportResponse(state, importResponse) {
    state.importResponse = importResponse;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
